import "./style.scss";

export const OfferLightLabel = () => (
    <>
        <span className="offer-light__label">спецпроект</span>
        <img alt="1 год" className="offer-light__year" src="https://storage.yandexcloud.net/ris-email/1yearSber.png" />
    </>
);
